// src/utils/formatters.js
// Shared utilities for formatting numbers, currency, units, and text across components (e.g., SalesInv, MemberMaint).
// Handles NaN/"N/A" edge cases for Supabase data; reusable for pricing, titles, and label gen.

export const toNumberOrNull = (val) => {
  if (val === null || val === undefined) return null;
  if (typeof val === 'number') return Number.isFinite(val) ? val : null;
  const s = String(val).trim();
  if (!s) return null;
  const cleaned = s.replace(/,/g, '').replace(/[^\d.-]/g, '');
  if (!cleaned || cleaned === '-' || cleaned === '.' || cleaned === '-.') return null;
  const n = Number(cleaned);
  return Number.isFinite(n) ? n : null;
};

export const toIntOr = (val, fallback = 1) => {
  const n = toNumberOrNull(val);
  return n === null ? fallback : Math.max(1, Math.floor(n));
};

export const formatUSD = (val) => {
  const n = toNumberOrNull(val);
  return n === null ? '' : `$${n.toFixed(2)}`;
};

export const formatPriceForTag = (val) => {
  const n = toNumberOrNull(val);
  return n === null ? '' : `$${Math.round(n)}`;
};

export const mmToPt = (mm) => (mm / 25.4) * 72;
export const inToPt = (inch) => inch * 72;

export const titleCase = (str) => {
  if (!str || str.length === 0) return '';
  // Capitalize first letter of each word, keep the rest exactly as-is
  return str
    .split(' ')
    .map((word) => (word ? word.charAt(0).toUpperCase() + word.slice(1) : ''))
    .join(' ');
};

// Date formatter for sale dates (used in SalesInv selectors)
export const formatSaleDate = (dateString) => {
  if (!dateString) return 'N/A';
  const utcDate = new Date(dateString);
  const year = utcDate.getUTCFullYear();
  const month = utcDate.getUTCMonth();
  const day = utcDate.getUTCDate();
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric', year: 'numeric' }).format(
    new Date(year, month, day)
  );
};

// FIXED: Add formatSaleDateNoYear to formatters for reuse (refactor goal: clean SalesInv)
export const formatSaleDateNoYear = (dateString) => {
  if (!dateString) return '';
  const d = new Date(dateString);
  return new Intl.DateTimeFormat('en-US', { month: 'short', day: 'numeric' }).format(d);
};

export const cleanNumberForDB = (val) => {
  if (!val && val !== 0) return null;
  const s = String(val).replace(/[^0-9.]/g, '');
  const n = Number(s);
  return Number.isFinite(n) ? n : null;
};

export const formatQty = (val) => {
  const n = Number(val);
  return Number.isFinite(n) ? Math.max(1, Math.floor(n)) : 1;
};

export const parseCSVString = (text) =>
  text ? text.split(',').map((s) => s.trim()).filter(Boolean) : [];

export const joinCSVArray = (arr) =>
  Array.isArray(arr) ? arr.join(',') : '';
